import { render } from "./TicketMessages.vue?vue&type=template&id=7fd83656&scoped=true"
import script from "./TicketMessages.vue?vue&type=script&lang=ts"
export * from "./TicketMessages.vue?vue&type=script&lang=ts"

import "./TicketMessages.vue?vue&type=style&index=0&id=7fd83656&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7fd83656"

export default script